import { ShieldAlert } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import { type MultipleSelectedValuesFilter } from '../types'
import FilterManagementDropdown from './FilterManagementDropdown'
import { filterByLabelAndValueCallback } from './utils'

const paymentReasonOptions: ComboboxFilterOption<string>[] = [
  { label: 'Delinquency Risk', value: 'delinquency_risk' },
  { label: 'Under Payment', value: 'under_payment' },
  { label: 'Over Payment', value: 'over_payment' },
  { label: 'Unexpected Amount', value: 'unexpected_amount' },
  { label: 'Missing Enrollment', value: 'missing_enrollment' },
]
const automationReasonOptions: ComboboxFilterOption<string>[] = [
  { label: 'Automation Reconciliation', value: 'automation_reconciliation' },
]

const manualReasonOptions: ComboboxFilterOption<string>[] = [
  { label: 'Incorrect Configuration', value: 'incorrect_configuration' },
  { label: 'Payments Issue', value: 'payments_issue' },
  { label: 'Backdate Requested', value: 'backdate_requested' },
  { label: 'Offboarding', value: 'offboarding' },
  { label: 'Dependent Age', value: 'dependent_age' },
  { label: 'Other', value: 'other' },
]

const reasonOptions: ComboboxFilterOption<string>[] = [
  ...paymentReasonOptions,
  ...automationReasonOptions,
  ...manualReasonOptions,
]

const ReasonFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredPaymentOptions = paymentReasonOptions?.filter(
    filterByLabelAndValueCallback(query)
  )
  const filteredAutomatedOptions = automationReasonOptions?.filter(
    filterByLabelAndValueCallback(query)
  )
  const filteredManualOptions = manualReasonOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[
          { groupLabel: 'Payments', options: filteredPaymentOptions || [] },
          { groupLabel: 'Automation', options: filteredAutomatedOptions || [] },
          { groupLabel: 'Manual', options: filteredManualOptions || [] },
        ]}
        placeholder='Search reasons to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={reasonOptions || []}
          noSelectionText='Reason'
          pluralIdentifier='reasons'
        >
          <ShieldAlert size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default ReasonFilter
